import React from 'react';
import T from 'prop-types';
// styles
import Color from 'color';
import styles from './Day.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const Day = ({ day, selected, select, color }) => {
  const {
    isToday,
    isCurrentMonth,
    date,
    hasEvents,
    number,
    isDailyCheckIn,
    hasRecoveryStats,
  } = day;

  const handleClick = () => {
    hasEvents && select(day);
  };

  const isTrueStats =
    isDailyCheckIn && hasRecoveryStats && hasRecoveryStats[0] === 'true';
  const isFalseStats =
    isDailyCheckIn && hasRecoveryStats && hasRecoveryStats[0] === 'false';
  const newColor =
    isFalseStats || (!isDailyCheckIn && isToday)
      ? color
      : isTrueStats
      ? 'orangered'
      : 'transparent';

  const style = {
    backgroundColor: hasEvents && Color(color).fade(0.8),
    color: hasEvents && color,
    borderColor: newColor,
  };

  return (
    <div
      className={cx('day', {
        today: isToday && !isDailyCheckIn,
        'different-month': !isCurrentMonth,
        selected: date.isSame(selected),
        'has-events': hasEvents,
      })}
      onClick={handleClick}
    >
      <div style={style} className={cx('day-number')}>
        {number}
      </div>
    </div>
  );
};

Day.propTypes = {
  day: T.shape({
    isToday: T.bool.isRequired,
    isCurrentMonth: T.bool.isRequired,
    date: T.object.isRequired,
    number: T.number.isRequired,
    hasRecoveryStats: T.array,
    isDailyCheckIn: T.bool,
  }).isRequired,
  selected: T.object.isRequired,
  select: T.func.isRequired,
  color: T.string.isRequired,
};

export default Day;



// WEBPACK FOOTER //
// ./src/components/Calendar/components/Day.jsx